import CustomElement from '~utilities/custom-element';

class Breadcrumb extends CustomElement {
	constructor() {
		super();
	}

	callback() {
		super.callback();
		
		const parent = this.parentNode;
		const items = [...this.element.querySelectorAll('a')];
		
		let nextItem = 1;
		
		while(parent.offsetWidth < this.element.offsetWidth && nextItem < items.length) {
			items[nextItem].classList.add('is--dotted');
			nextItem++;
		}
	}
}

export default Breadcrumb;